module.exports = __webpack_public_path__ + "img/undraw_happy_women_day_fbjt.79b505d4.svg";